import React from 'react';
import { FileViewer } from '../viewer/file-viewer.js';
import 'classnames';
import 'lodash';
import 'ricos-context';
import 'wix-rich-content-common/libs/Tooltip';
import '../style-inject.es-746bb8ed.js';
import '../dataHooks.js';
import '../types.js';
import '../icons/getIcon.js';
import '../lib/fileExtensionToType.js';
import '../icons/docIcon.js';
import '../icons/folderIcon.js';
import '../icons/imageIcon.js';
import '../icons/otherIcon.js';
import '../icons/pdfIcon.js';
import '../icons/pptIcon.js';
import '../icons/vid-aud-icon.js';
import '../icons/xlsIcon.js';
import '../icons/errorIcon.js';
import '../icons/LoaderIcon.js';
import '../icons/readyIcon.js';
import '../icons/downloadIcon.js';

const File = ({ settings = {}, componentData, node }) => {
  const isLoading = node.attrs.loading;
  const error = node.attrs.error;
  if (error) {
    componentData.error = error;
  }
  const tempDataPlaceHolder = node.attrs.tempData;
  return /* @__PURE__ */ React.createElement(
    FileViewer,
    {
      componentData,
      settings,
      isLoading,
      tempDataPlaceHolder
    }
  );
};

export { File };
//# sourceMappingURL=component.js.map
